import ManageUsers from "../pages/security/manageUsers/ManageUsers";
import AddUser from "../pages/security/manageUsers/NewUser";
import DetailedUser from "../pages/security/manageUsers/DetailUsers";
import EditUser from "../pages/security/manageUsers/EditUser";
import ManageEmployees from "../pages/security/manageEmployees/ManageEmployees";
import NewEmployee from "../pages/security/manageEmployees/NewEmployee";
import DetailEmployee from "../pages/security/manageEmployees/DetailEmployee";
import EditEmployee from "../pages/security/manageEmployees/EditEmployee";
import PasswordPreferences from "../pages/security/PasswordPreferences";
import ManageAuditTrails from "../pages/security/auditTrail/ManageAuditTrails";
import SearchAuditTrails from "../pages/security/auditTrail/SearchAuditTrails";
import ManageRoles from "../pages/security/rolesAndPermissions/ManageRoles";
import NewRole from "../pages/security/rolesAndPermissions/NewRole";
import DetailRole from "../pages/security/rolesAndPermissions/DetailRole";
import EditRole from "../pages/security/rolesAndPermissions/EditRole";
import DetailTwoFA from "../pages/security/twoFactorAuthentication/DetailTwoFA";
import MakerChecker from "../pages/security/authorization/MakerChecker";
import DetailAuditTrails from "../pages/security/auditTrail/DetailAuditTrails";
import Profile from "../pages/security/userProfile/Profile";

export default [
  {
    path: "/sms0100",
    component: ManageUsers,
    isProtected: true,
  },
  {
    path: "/add-sms0100",
    component: AddUser,
    isProtected: true,
  },
  {
    path: "/view-sms0100",
    component: DetailedUser,
    isProtected: true,
  },
  {
    path: "/edit-sms0100",
    component: EditUser,
    isProtected: true,
  },
  {
    path: "/sms0200",
    component: ManageEmployees,
    isProtected: true,
  },
  {
    path: "/view-employee",
    component: DetailEmployee,
    isProtected: true,
  },
  {
    path: "/add-employee",
    component: NewEmployee,
    isProtected: true,
  },
  {
    path: "/edit-employee",
    component: EditEmployee,
    isProtected: true,
  },

  // PASSWORD PREFERENCE

  {
    path: "/sms0300",
    component: PasswordPreferences,
    isProtected: true,
  },
  {
    path: "/sms0500",
    component: ManageAuditTrails,
    isProtected: true,
  },
  {
    path: "/search-audit-trail",
    component: SearchAuditTrails,
    isProtected: true,
  },
  {
    path: "detail-audit-trail",
    component: DetailAuditTrails,
    isProtected: true,
  },

  // MANAGE ROLES

  {
    path: "/sms0400",
    component: ManageRoles,
    isProtected: true,
  },

  {
    path: "/new-role",
    component: NewRole,
    isProtected: true,
  },

  {
    path: "/detail-role",
    component: DetailRole,
    isProtected: true,
  },

  {
    path: "/edit-role",
    component: EditRole,
    isProtected: true,
  },
  {
    path: "/sms0700",
    component: DetailTwoFA,
    isProtected: true,
  },

  // AUTHORIZATION
  {
    path: "/sms0600",
    component: MakerChecker,
    isProtected: true,
  },
  {
    path: "/profile",
    component: Profile,
    isProtected: true,
  },
];
